import { createFileRoute, redirect } from "@tanstack/react-router";
import { AppLayout } from "@/components/layout/app-layout";
import { authClient, NO_AUTH } from "@/lib/auth-client";

export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ location }) => {
    if (NO_AUTH) return;
    const { data } = await authClient.getSession();
    if (!data?.session) throw redirect({ to: "/sign-in", search: { redirect: location.href } });
  },
  component: AppLayout,
});
